import React from 'react';

import ColumnLayout from '../layouts/ColumnLayout';

export default function Calendar() {
  return (
    // TODO - Handle the Google Calendar integration consent screen in this view.
    <div>
      <ColumnLayout childs={[
        (<h1>Google Calendar</h1>),
      ]} />
    </div>
  );
}
